import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_TRANSACTIONS = 'transactionsGraph/TRANSACTIONS';
export const FETCH_TRANSACTIONS_OK = 'transactionsGraph/TRANSACTIONS_OK';
export const FETCH_TRANSACTIONS_FAILED = 'transactionsGraph/TRANSACTIONS_FAILED';

/**
 * Action Creators
 */

export function fetchTransactionGraph(args = {}) {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_TRANSACTIONS });
      const transactions = await API.getTransactionGraph(args);
      dispatch({
        type: FETCH_TRANSACTIONS_OK,
        payload: transactions.data,
      });
    } catch (err) {
      dispatch({ type: FETCH_TRANSACTIONS_FAILED, error: err.response || err.message });
    }
  };
}

/**
 * Reducers
 */

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: false,
  errors: {},
  transactions: {},
};

export default function transactions(state = initialState, action) {
  switch (action.type) {
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        error: false,
        errors: {},
        isLoading: true,
        isLoaded: false,
      };

    case FETCH_TRANSACTIONS_OK:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        transactions: action.payload,
        totalPages: action.totalPages,
      };

    case FETCH_TRANSACTIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: true,
        errors: action.error,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/transactionGraph.js